import { GridItem } from '@tvg/fuse/grid';
import { TypographyComponent as Typography } from '@tvg/fuse/typography';
import classNames from 'classnames';
import React from 'react';
import styles from './Facet.module.css';
import FacetItemList from './FacetItemList';

export function Facet() {
  return (
    <GridItem l={3} className={classNames(styles.facet, 'grid-item desktop-filters')}>
      <div className="accordion-container accordion-facet-container" data-testid="accordion-facet-container">
        <Typography className={styles.facet__title} data-testid="test-facet-heading" type="heading" size="4" tag="h2">
          Filter
        </Typography>
        <FacetItemList />
      </div>
    </GridItem>
  );
}
